var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwoImages = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.96 8.247a1.5 1.5 0 1 0-.623-2.934 1.5 1.5 0 0 0 .623 2.934Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.377 3.937a3 3 0 0 0-2.31 3.559l1.87 8.803a3 3 0 0 0 3.559 2.31l8.803-1.87a3 3 0 0 0 2.31-3.559l-1.87-8.803a3 3 0 0 0-3.559-2.31l-8.803 1.87ZM4.022 7.08a1 1 0 0 1 .77-1.186l8.804-1.872a1 1 0 0 1 1.186.77l1.635 7.692-6.926-3.66a2 2 0 0 0-2.657.752l-1.677 2.842L4.022 7.08Zm4.534 3.513 7.665 4.05a.998.998 0 0 1-.338.14l-8.803 1.87a1 1 0 0 1-1.186-.77l-.122-.572 2.784-4.718Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.069 20.06c-.525-.116-.52-.864.005-.976l2.318-.493a.499.499 0 0 1 .208 0l4.996 1.062a1 1 0 0 0 1.186-.77l1.871-8.803a1 1 0 0 0-.77-1.186l-.9-.192a.5.5 0 0 1-.385-.385l-.227-1.07a.5.5 0 0 1 .593-.593l1.335.283a3 3 0 0 1 2.31 3.559l-1.87 8.803a3 3 0 0 1-3.559 2.31c-1.842-.391-4.981-1.08-7.111-1.55Z",
  fill: "currentColor"
})));
export default SvgTwoImages;